// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const TraceStatusSchema = z.enum(['ABORTED','BLOCKED','COMPLETED','FAILED','PAUSED','RUNNING'] as const);

export type TraceStatusType = `${z.infer<typeof TraceStatusSchema>}`

export default TraceStatusSchema;
